import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProcessedInvoiceTable = ({ invoices = [], isLoading = false, onOpenInvoice }) => {
  const formatCurrency = (amount, currency = 'GBP') => {
    if (amount === null || amount === undefined) return '—';
    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return formatter.format(amount);
  };

  if (isLoading) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 text-center">
        <div className="flex flex-col items-center space-y-3">
          <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary" />
          </div>
          <p className="text-sm text-muted-foreground">Loading processed invoices…</p>
        </div>
      </div>
    );
  }

  if (!invoices?.length) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 text-center">
        <div className="flex flex-col items-center space-y-3">
          <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
            <Icon name="Archive" size={20} className="text-muted-foreground" />
          </div>
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">No processed invoices</h3>
            <p className="text-xs text-muted-foreground">
              Select a different date or export more invoices from the review queue.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/40 border-b border-border">
            <tr>
              {['Vendor', 'Invoice #', 'Exported On', 'Exported By', 'Total', 'Actions']?.map((header) => (
                <th
                  key={header}
                  className="px-4 py-3 text-left text-sm font-medium text-muted-foreground"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {invoices?.map((invoice) => (
              <tr
                key={invoice?.id}
                className="border-b border-border hover:bg-muted/30 transition-smooth"
              >
                <td className="px-4 py-3">
                  <div className="flex flex-col">
                    <span className="text-sm font-medium text-foreground">{invoice?.vendor || 'Unknown vendor'}</span>
                    <span className="text-xs text-muted-foreground">{invoice?.filename}</span>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span className="font-mono text-sm text-foreground">{invoice?.invoiceNumber || '—'}</span>
                </td>
                <td className="px-4 py-3 text-sm text-foreground">
                  {invoice?.exportedOnLabel || '—'}
                </td>
                <td className="px-4 py-3 text-sm text-foreground">
                  {invoice?.exportedBy || 'System'}
                </td>
                <td className="px-4 py-3 font-mono text-sm text-foreground">
                  {formatCurrency(invoice?.totalAmount, invoice?.currency)}
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center space-x-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="ExternalLink"
                      onClick={() => onOpenInvoice?.(invoice?.id)}
                      title="Open in editor"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProcessedInvoiceTable;
